// GPT reasoning summaries lead each block with a bold title:
// `**Title**\n\nI think I will do it like this…`. Lift that title into the
// row heading ("Thinking: Title") and strip the leading blank lines so the
// body starts on its first real line. Works mid-stream too: while the title
// is still arriving (opening `**` seen, closing `**` not yet), the partial
// shows in the heading and the body stays empty until the title closes.

export interface ParsedThinking {
  /** Title text without markers, or null when the block has no bold title. */
  title: string | null;
  /** Body with the title line and its trailing blank lines removed. */
  body: string;
}

export function parseThinking(text: string): ParsedThinking {
  const closed = /^\s*\*\*(.+?)\*\*/s.exec(text);
  if (closed) {
    return { title: closed[1].trim(), body: text.slice(closed.index + closed[0].length).replace(/^\s+/, '') };
  }
  // Title still streaming in — opening `**` seen, not yet closed.
  const opening = /^\s*\*\*([^]*)$/.exec(text);
  if (opening) {
    return { title: opening[1].trim() || null, body: '' };
  }
  return { title: null, body: text };
}

/** Heading for a thinking row, given its (possibly partial) parsed title. */
export function thinkingHeading(title: string | null): string {
  return title ? `Thinking: ${title}` : 'Thinking';
}
